export default __webpack_public_path__ + "static/media/pastaang.49c2992e.avif";